import { cn } from '@/lib/utils';

interface CompactScoreBarProps {
  inputScore: number;
  enhancedScore: number;
  className?: string;
}

export function CompactScoreBar({ inputScore, enhancedScore, className }: CompactScoreBarProps) {
  const gap = enhancedScore - inputScore;
  
  return (
    <div className={cn("flex items-start gap-4 w-full", className)}>
      {/* LEFT: With Cosmo - Big Score */}
      <div className="flex flex-col shrink-0">
        <span className="text-xs text-muted-foreground">With Cosmo</span>
        <div className="flex items-baseline gap-1">
          <span className="text-2xl font-bold text-primary">{Math.round(enhancedScore)}</span>
          <span className="text-sm text-green-500">(+{Math.round(gap)})</span>
        </div>
      </div>
      
      {/* RIGHT: Bar Section */}
      <div className="flex-1 min-w-0 flex flex-col gap-1">
        {/* Labels above bar - EDGE-AWARE positioning */}
        <div className="relative h-5 text-xs">
          {/* Initial Prompt - uses dynamic translateX to stay in bounds */}
          <div 
            className="absolute whitespace-nowrap"
            style={{ 
              left: `${inputScore}%`,
              transform: `translateX(-${inputScore}%)`
            }}
          >
            <span className="text-muted-foreground">Initial Prompt</span>
            <span className="ml-1 font-semibold">{Math.round(inputScore)}</span>
          </div>
          {/* Enhanced score - same edge-aware positioning */}
          <div 
            className="absolute whitespace-nowrap"
            style={{ 
              left: `${enhancedScore}%`,
              transform: `translateX(-${enhancedScore}%)`
            }}
          >
            <span className="font-bold text-primary">{Math.round(enhancedScore)}</span>
          </div>
        </div>
        
        {/* Progress bar */}
        <div className="relative h-2 bg-muted-foreground/20 rounded-full">
          {/* Input score segment */}
          <div 
            className="absolute inset-y-0 left-0 bg-primary/30 rounded-l-full"
            style={{ width: `${inputScore}%` }}
          />
          {/* Gap segment */}
          <div 
            className="absolute inset-y-0 bg-gradient-to-r from-primary/70 to-primary rounded-r-full"
            style={{ left: `${inputScore}%`, width: `${gap}%` }}
          />
          {/* Divider marker */}
          <div 
            className="absolute top-1/2 w-0.5 h-3 bg-foreground rounded"
            style={{ left: `${inputScore}%`, transform: 'translateX(-50%) translateY(-50%)' }}
          />
        </div>
        
        {/* Scale: 0 and 100 */}
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>0</span>
          <span>100</span>
        </div>
      </div>
    </div>
  );
}
